import { call, put } from 'typed-redux-saga';

import { goloomSdk } from '../../../../../shared/features/goloom-sdk';
import { hideNotification } from '../../../../../shared/features/notifications/ps-notifications';
import { createLogger } from '../../../../../shared/helpers/loggerFacade';
import { cloudApi } from '../../../../../shared/helpers/transport';
import { resetCall } from '../../../slice';
import { DisconnectPayload, NotificationId } from '../../../types';
import {
    disconnectedFromConferenceAction,
    disconnectedFromConferenceDoneAction,
    setShowScreenSharingPermissionsHelp,
} from '../slice';

const logger = createLogger('disconnect');

export function* disconnectConferenceSaga(payload: DisconnectPayload) {
    logger.event('Disconnecting from conference', {
        additional: {
            method: 'disconnectConferenceSaga',
            disconnectPayload: payload,
        },
    });
    yield put(disconnectedFromConferenceAction());
    yield call([goloomSdk, goloomSdk.destroy]);

    yield put(hideNotification(NotificationId.LIMIT_ERROR));
    yield put(setShowScreenSharingPermissionsHelp(false));

    yield* put(resetCall());

    yield put(disconnectedFromConferenceDoneAction(payload));
    yield* call([cloudApi, cloudApi.stopCaptureConferenceCluster]);
}
